import React from "react";
import GenreFilter from "@/pages/benchmark/components/GenreFilter";

// 品类游戏筛选器
export const renderGenreSubGenre = (props: any): React.ReactElement => {
  const { key, value, options, onChange, locale, getLocalText, name, allInfo, lftName, rtName, ...restProps } = props || {};
  // 组件标题等中英文配置

  const language = {
    en: {
      'button_region': name || 'Genre',
      'button_market': lftName || 'Genre',
      'region_title': rtName || 'Main Genre',
    },
    cn: {
      'button_region': name || '品类',
      'button_market': lftName || '品类',
      'region_title': rtName || '主品类',
    }
  };

  return <GenreFilter
    language={language}
    matchButtonWidth
    key={key}
    className={'search-items-country js-search-items-country'}
    value={value}
    onChange={(value) => {
      const newValue = {
        genre: value?.regions ?? [],
        subgenre: value?.markets ?? [],
        type: value?.type === 'region' ? 'genre' : 'subgenre',
      };
      onChange(key, newValue);
    }}
    locale={locale}
    regionCountry={options}
    {...restProps}
  />;

};
